import { motion } from "framer-motion";
import { useState } from "react";
import { GALLERY, revealUp } from "../../lib/mrs";

export const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative bg-[#0a0b0a] py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-20"
    >
      <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 md:mb-20 gap-6">
        <motion.h2
          variants={revealUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="font-display font-light text-[#eae7e0] leading-[1.05] text-4xl md:text-5xl lg:text-6xl tracking-tight max-w-xl"
        >
          Spaces that breathe.
        </motion.h2>
        <motion.p
          variants={revealUp}
          custom={1}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="text-sm md:text-base text-[#9ca399] max-w-sm"
        >
          A glimpse of interiors, exteriors and living elements from projects
          across Bangalore & Mangalore.
        </motion.p>
      </div>

      <div
        className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6"
        onMouseLeave={() => setActive(null)}
      >
        {GALLERY.map((g, i) => {
          const spans = [
            "md:col-span-7 aspect-[4/3]",
            "md:col-span-5 aspect-[4/3] md:mt-16",
            "md:col-span-5 aspect-[4/3]",
            "md:col-span-7 aspect-[4/3] md:-mt-16",
          ];
          return (
            <motion.div
              key={i}
              variants={revealUp}
              custom={i % 2}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-60px" }}
              onMouseEnter={() => setActive(i)}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden cursor-pointer transition-opacity duration-500 ${
                spans[i]
              } ${active !== null && active !== i ? "opacity-45" : "opacity-100"}`}
            >
              <img
                src={g.url}
                alt={g.label}
                className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0b0a]/80 via-transparent to-transparent" />
              <div className="absolute inset-0 ring-1 ring-inset ring-[#eae7e0]/10" />
              <div className="absolute bottom-0 left-0 p-6 md:p-8">
                <span className="font-display text-xl md:text-2xl text-[#eae7e0]">
                  {g.label}
                </span>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
};
